import React from "react";
import { FormattedMessage } from "react-intl";
import { useAuth, useLinks } from "hooks";
import PageTitle, { LAYOUT } from "components/PageTitle";
import { NavList } from "components/Nav";

/**
 * UserSettingsTitle
 *
 * Personal settings page title with its tabs below it. Scheduling shows only to users who can schedule interviews.
 */
const UserSettingsTitle = (props) => {
  const links = useLinks();
  const { canScheduleInterviews } = useAuth();

  const navItems = [
    {
      label: <FormattedMessage id="UserSettings.Tabs.Account" />,
      to: links.user_settings_account,
      isActive: true,
      isPermissible: true,
    },
    {
      label: <FormattedMessage id="UserSettings.Tabs.Scheduling" />,
      to: links.user_settings_scheduling,
      isActive: true,
      isPermissible: canScheduleInterviews,
    },
  ].filter((item) => item.isPermissible);

  return (
    <PageTitle
      title={<FormattedMessage id="UserSettings.Title" />}
      layout={LAYOUT.vertical}
      actionBar={<NavList pages={navItems} />}
      {...props}
    />
  );
};

export default UserSettingsTitle;
